import _ from 'lodash';
import { User } from 'src/app/auth/user';


// Define the OrgMemberInfoClass type
type OrgMemberInfoClass = {
	org_id: string;
	org_name: string;
	url_safe_org_name: string;
	org_metadata: object;
	user_role: string;
	inherited_user_roles_plus_current_role: string[];
	org_role_structure: string;
	additional_roles: string[];
	user_permissions: string[];
};


//see exactly what info you need and refactor the user model after removing the other providers to pass your needs 


export type PartialUser = {
	[P in keyof User]?: User[P] extends object ? Partial<User[P]> : User[P];
};

function UserModel(data: PartialUser): User {
	data = data || {};

	return _.defaultsDeep(data, {
		uid: '',
		role: null, // guest
		data: {
			displayName: 'Guest User',
			photoURL: '',
			email: '',
			shortcuts: [],
			settings: {},
			loginRedirectUrl: ''
		},
		sub: '',
		first_name: '',
		last_name: '',
		picture_url: '',
		org_id_to_org_member_info: {},
		properties: {
			chosen_font_size: '100%',	
			chosen_language: 'bg',
			phone_number: ''
		}
	});
}

export default UserModel;